<template>
    <quillEditor
        :options="editorOption"
        @change="onEditorChange($event)"
        class="roma-editor"
        :content="info"
    >
    </quillEditor>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import ResourcesMixin from "@/mixins/resourcesMixin";
export default {
    props: ["data", "uid", "content"],
    mixins: [ResourcesMixin],
    data() {
        return {
            editorOption: {
                placeholder: "Descripción *"
            },
            info: this.content
        };
    },
    components: {
        quillEditor
    },
    methods: {
        onEditorChange({ html }) {
            this.data(html, this.uid);
        }
    },
    watch: {
        content() {
            this.info = this.content;
        }
    }
};
</script>

<style></style>
